"use strict";

exports.__esModule = true;
exports["default"] = createLocationMiddleware;
var _ActionTypes = _interopRequireDefault(require("./ActionTypes"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function createLocationMiddleware(_ref) {
  var makeLocationDescriptor = _ref.makeLocationDescriptor,
    makeLocation = _ref.makeLocation;
  return function locationMiddleware() {
    return function (next) {
      return function (action) {
        var type = action.type,
          payload = action.payload;
        switch (type) {
          case _ActionTypes["default"].TRANSITION:
          case _ActionTypes["default"].CREATE_HREF:
            return next({
              type: type,
              payload: makeLocationDescriptor(payload)
            });
          case _ActionTypes["default"].CREATE_LOCATION:
            return makeLocation(next({
              type: type,
              payload: makeLocationDescriptor(payload)
            }));
          case _ActionTypes["default"].UPDATE_LOCATION:
            return next({
              type: type,
              payload: makeLocation(payload)
            });
          default:
            return next(action);
        }
      };
    };
  };
}
module.exports = exports["default"];